export function appendCardGroup(cards, selectedCardIds) {
    const selected = new Set(selectedCardIds);
    const originalIndex = new Map(cards.map((card, index) => [card.cardId, index]));
    const selectedIndex = new Map(selectedCardIds.map((id, index) => [id, index]));

    const grouped = cards.map(card => ({
        ...card,
        // Older groups move up one slot. The newly-created group is appended
        // after them and remains ahead of all still-ungrouped cards.
        group: selected.has(card.cardId) ? 1 : (Number(card.group) > 0 ? Number(card.group) + 1 : 0),
    }));
    const counts = grouped.reduce((result, card) => {
        result[card.group] = (result[card.group] || 0) + 1;
        return result;
    }, {});
    const normalized = grouped.map(card => ({
        ...card,
        group: card.group > 0 && counts[card.group] === 1 ? 0 : card.group,
    }));

    return normalized.sort((a, b) => {
        if (a.group !== b.group) return b.group - a.group;
        if (a.group === 1 && selected.has(a.cardId) && selected.has(b.cardId)) {
            return selectedIndex.get(a.cardId) - selectedIndex.get(b.cardId);
        }
        return originalIndex.get(a.cardId) - originalIndex.get(b.cardId);
    });
}
